






































































import Header from '@/components/common/Header.vue';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';
import { Component, Vue } from 'vue-property-decorator';
import { accountSettingsService } from '@/services/AccountSettingsService';
import { workspaceService } from '@/services/WorkspaceService';
import RemoveWorkspaceDialog from '@/components/settings/RemoveWorkspaceDialog.vue';

@Component({
  components: {
    Header,
    PriceWithCurrency,
    RemoveWorkspaceDialog,
  },
})
export default class ChoosePaymentMethod extends Vue {
  workspaceId = 0;
  activatedTrial = true;
  isMailSendSuccessfully = false;
  isLoading = false;
  subject: any = '';
  formDescription: any = '';
  isBtnDisabled = false;
  isPreproduct = true;

  mounted() {
    this.isPreproduct = true;
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.getSettings();
    this.subject = this.$t('billing.contractContact');
    this.formDescription = this.$t('billing.contractContact');
  }
  closeModal() {
    this.isMailSendSuccessfully = false;
  }
  getSettings() {
    accountSettingsService
      .getSettings()
      .then((data: any) => {
        this.activatedTrial = data.trial_activated;
      })
      .catch(() => {});
  }
  send() {
    const data = new FormData();
    data.append('type', this.subject);
    data.append('description', this.formDescription);

    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    workspaceService
      .createTicket(this.workspaceId, data)
      .then(() => {
        this.isLoading = false;
        this.isMailSendSuccessfully = true;
        this.isBtnDisabled = true;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
